import { render, staticRenderFns } from "./CardOrderHistory.vue?vue&type=template&id=04790772&scoped=true&"
import script from "./CardOrderHistory.vue?vue&type=script&lang=js&"
export * from "./CardOrderHistory.vue?vue&type=script&lang=js&"
import style0 from "./CardOrderHistory.vue?vue&type=style&index=0&id=04790772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04790772",
  null
  
)

export default component.exports